import { PRESUPUESTADOR_SET_NEW_DELIVERY_COST } from './constants'

export function setNewDeliveryCost(value) {
    return {
        type: PRESUPUESTADOR_SET_NEW_DELIVERY_COST,
        data: { newDeliveryCost: value }
    }
}

export function reducer(state, action) {
    if (action.type === PRESUPUESTADOR_SET_NEW_DELIVERY_COST) {
        return {
            ...state,
            costoPatentamiento: action.data.newDeliveryCost,
            costoPatentamientoOriginal: state.costoPatentamientoOriginal ?? state.costoPatentamiento,
        }
    }
    return state
}
